import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {PlatformsService} from '@core/services/platforms.service';
import {Router, RoutesRecognized} from '@angular/router';
import {SeoService} from '@core/services/seo.service';
import {environment} from '@env/environment';
import {filter, map} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    // Environment data.
    readonly isProduction = environment.production;
    readonly version = environment.version;

    private _routerSubscription: Subscription;

    constructor(private _router: Router,
                private _seo: SeoService,
                private _platforms: PlatformsService,
                @Inject(PLATFORM_ID) private _platformId: object) {
    }

    ngOnInit() {
        // Observe the router events and get the url.
        const observable$ = this._router.events.pipe(
            filter(event => event instanceof RoutesRecognized),
            map((event: RoutesRecognized) => {
                // Get the extra data and url.
                let root = event.state.root.firstChild;

                while (root.firstChild) {
                    if (!root.firstChild) {
                        break;
                    }
                    root = root.firstChild;
                }

                const extra = root.data;

                // Create a new object from the extra data.
                return Object.assign({}, extra);
            })
        );

        // Subscribe to the router observable and set the SEO on each event and scroll to the top.
        this._routerSubscription = observable$
            .subscribe(meta => this._seo.set(meta));
    }

    ngOnDestroy() {
        this._routerSubscription.unsubscribe();
    }

}
